"use strict";
exports.__esModule = true;
exports.OnboardingRoutes = void 0;
var OnboardingRoutes;
(function (OnboardingRoutes) {
    OnboardingRoutes["Company"] = "company";
    OnboardingRoutes["TemplateEditor"] = "edit";
    OnboardingRoutes["GenerateGemEmbed"] = "embed-in-gem";
})(OnboardingRoutes = exports.OnboardingRoutes || (exports.OnboardingRoutes = {}));
//# sourceMappingURL=onboarding-enum.js.map